module.exports = __webpack_public_path__ + "img/diashow (2).a49d371.jpg";